import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateAuthAdmin = {
  authAdmin: { data: null, loading: false, error: null },
};

export const authAdmin = createAsyncThunk('user/authAdmin', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .get(`/admin/auth`)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerAuthAdmin = {
  [authAdmin.pending]: (state) => {
    state.authAdmin.loading = true;
  },
  [authAdmin.fulfilled]: (state, action) => {
    state.authAdmin.loading = false;
    state.authAdmin.data = action.payload;
    state.authAdmin.error = null;
  },
  [authAdmin.rejected]: (state, action) => {
    state.authAdmin.loading = false;
    state.authAdmin.error = action.payload;
  },
};
